import useSisenseScyEventNoCourseDropdown from "./UseSisenseScyEventNoCourseDropdown";

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import Constants from "@usas/ui-web/utils/Constants";

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const SisenseScyEventNoCourseDropdown = ({ label, name, value, error, message, onChange }) => {
  const { scyEventNoCourseOptions } = useSisenseScyEventNoCourseDropdown();

  return !scyEventNoCourseOptions.options
    ? <span className={global.LoadingMsg}>{Constants.LOADING_MSG}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={scyEventNoCourseOptions.options}
        name={name}
        value={value}
        onChange={onChange}
        isLoading={!scyEventNoCourseOptions.options}
      />
    );
};

export default SisenseScyEventNoCourseDropdown;